import { Pipe, PipeTransform } from '@angular/core';

import { fieldHeightIsShorterThenMin } from '../../enclosure/helpers/positions-calculations.helper';
import { IProduct } from '../../shared/models/product.model';
import { IEnclosure } from '../../shared/models/enclosure.model';
import { EnclosureTabType } from '../../shared/models/project.model';

@Pipe({
    name: 'zoomOutSwitchboardUnavailable',
    standalone: false
})
export class ZoomOutSwitchboardUnavailablePipe implements PipeTransform {

  transform(zoomFactor: number,
            products: IProduct[],
            selectedEnclosure: IEnclosure,
            switchboardContainerEl: HTMLElement,
            zoomControlsContainerEl: HTMLElement,
            tab: EnclosureTabType): boolean {
    if (tab !== EnclosureTabType.DISPOSITION || !switchboardContainerEl || !zoomControlsContainerEl || !selectedEnclosure) {
      return false;
    }

    return fieldHeightIsShorterThenMin(products, selectedEnclosure, switchboardContainerEl, zoomControlsContainerEl, zoomFactor - 1);
  }

}
